// frontend/src/utils/boxLineStyle.js
export function boxLineColor(line, fallback) {
  if (line.calculation_kind === 'replay' && !boxLineActive(line)) {
    return line.is_top ? 'red' : 'blue';
  }
  if (line.manual_strategy === 'turning_point') {
    return line.is_top ? 'pink' : 'purple';
  }
  return fallback ?? (line.is_top ? 'red' : 'blue');
}

export function boxLineActive(line) {
  return Boolean(line.most_line && line.strategy_active);
}

export function boxLineStroke(line, fallbackColor, inactiveDash) {
  const active = boxLineActive(line);
  return {
    stroke: boxLineColor(
      line,
      fallbackColor ??
        (line.is_top
          ? line.n_peaks === 2
            ? 'orange'
            : 'red'
          : line.n_peaks === 2
            ? 'brown'
            : 'blue'),
    ),
    strokeWidth: active ? 2 : 1,
    dashStyle: active
      ? 'Solid'
      : (inactiveDash ?? (line.n_peaks === 2 ? 'DashDot' : 'Dash')),
  };
}
